import api from "@/service/Api/Api";
import { apiResponse } from "@/service/Api/Api";

export interface postAdministratorInvitationUrlRequest {
  administrator_name: string;
}

export interface postAdministratorInvitationUrlResponse {
  administrator_invitation_url: string;
  url_expires_timestamp: number;
}

export default {
  postAdministratorInvitationUrl(
    data: postAdministratorInvitationUrlRequest,
    volumeLicensesId: string
  ): Promise<postAdministratorInvitationUrlResponse & apiResponse> {
    return api<
      postAdministratorInvitationUrlRequest,
      postAdministratorInvitationUrlResponse
    >({
      endpoint:
        "volume-licenses/" +
        volumeLicensesId +
        "/web-api/administrator-invitation-url",
      method: "POST",
      body: data,
    });
  },
};
